export default class Validation {
    public static validPhone(phone: string) {
        phone = phone.replace(/\D/g, '');

        if (phone.startsWith('1')) {
            return phone.length === 11;
        }

        return phone.length === 10;
    }

    public static validEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    public static validUrl(url: string) {
        return /^(https?:\/\/)?(www\.)?[\w\-]+(\.[\w\-]+)+([\/?#].*)?$/.test(url);
    }

    public static validPassword(password: string){
        return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*?])[A-Za-z\d!@#$%^&*?]{8,}$/.test(password);
    }
}